export function twoDecimalRound(val: number): number {
    // tslint:disable-next-line:no-magic-numbers
    return Math.round((val + Number.EPSILON) * 100) / 100;
}
